import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

// constants
import { IMAGE_PATH, screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";

// actions
import { fetchEventDetails } from "DashboardUserAction";
import { openIntegrationModal } from "SettingActions";

// components
import IntegrationDetails from "./integration-details";
import BetaFeature from "BetaFeature";

class Apis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: "",
    };
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session, (res) => {});
  }

  openLink(obj) {
    //console.log("obj", obj);
    if (obj.link) {
      window.open(obj.link, "_blank");
    } else {
      let payload = {};
      payload.showModal = true;
      payload.key = obj.key;
      payload.modalTitle = obj.modaltitle;
      this.props.openIntegrationModal(payload);
    }
  }

  render() {
    var { session, deviceSize } = this.props;
    let items = [
      {
        title: LocaleStrings.integration_title_apidocs,
        desc: LocaleStrings.integration_desc_apidocs,
        linktext: LocaleStrings.integration_linktext_apidocs,
        link: "",
        icon: "integration_apidocs.svg",
        key: "api",
        modaltitle: LocaleStrings.integration_modal_title_apidocs,
      },
      {
        title: LocaleStrings.integration_title_embed,
        desc: LocaleStrings.integration_desc_embed,
        linktext: LocaleStrings.integration_linktext_embed,
        link: "",
        icon: "integration_embed.svg",
        key: "widget",
        modaltitle: LocaleStrings.integration_modal_title_embed,
      },
      {
        title: LocaleStrings.integration_title_tickets,
        desc: LocaleStrings.integration_desc_tickets,
        linktext: LocaleStrings.integration_linktext_tickets,
        link: "",
        icon: "integration_tickets.svg",
        key: "ticket",
        modaltitle: LocaleStrings.integration_modal_title_tickets,
      },
      {
        title: LocaleStrings.integration_title_livescreen,
        desc: LocaleStrings.integration_desc_livescreen,
        linktext: LocaleStrings.integration_linktext_livescreen,
        link: "",
        icon: "integration_live.svg",
        key: "live",
        modaltitle: LocaleStrings.integration_modal_title_livescreen,
      },
      {
        title: LocaleStrings.integration_title_regforms,
        desc: LocaleStrings.integration_desc_regforms,
        linktext: LocaleStrings.integration_linktext_regforms,
        link: "",
        icon: "integration_form.svg",
        key: "form",
        modaltitle: LocaleStrings.integration_modal_title_regforms,
      },
      {
        title: LocaleStrings.integration_title_abstracts,
        desc: LocaleStrings.integration_desc_abstracts,
        linktext: LocaleStrings.integration_linktext_abstracts,
        link: "",
        icon: "integration_abstract.png",
        key: "abstract",
        modaltitle: LocaleStrings.integration_modal_title_abstracts,
      },
      {
        title: LocaleStrings.integration_title_zapier,
        desc: LocaleStrings.integration_desc_zapier,
        linktext: LocaleStrings.integration_linktext_zapier,
        link: "https://zapier.com/apps/eventify/integrations",
        icon: "integration_zapier.png",
        key: "zapier",
        modaltitle: LocaleStrings.integration_modal_title_zapier,
      },
    ];
    return (
      <>
        <div className="panel noborder-panel">
          <div className="content-header-bar">
            <div className="vertical-align-center">
              <div className="custom-text3-primary-medium">
                {LocaleStrings.headertext_integrations}
              </div>
            </div>
          </div>
          <div className="clearfix" />

          <div
            className="panel-body scrollable-content"
            style={{ height: deviceSize.height - screenHeightLeftFromTop }}
          >
            <div className="integration_parent">
              {_.map(items, (obj, index) => {
                return (
                  <div className="integration_box">
                    <div className="upper_section">
                      <div className="vertical-align-center pb-3">
                        <div>
                          <img src={`${IMAGE_PATH}integration/${obj.icon}`} />
                        </div>
                        <div className="custom-text3-primary-medium pl-20">
                          {obj.title}

                          {obj.key !== "api" ? (
                            <span className="ps-1">
                              <BetaFeature />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="desc_height custom-text1-secondary-normal">
                        {obj.desc}
                      </div>
                    </div>
                    <div
                      className="lower_section text-right custom-text1-theme-medium pointer"
                      onClick={() => this.openLink(obj)}
                    >
                      {obj.linktext}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <IntegrationDetails />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps, {
  openIntegrationModal,
  fetchEventDetails,
})(Apis);
